export const apiUrl = `http://localhost:8080`;

export const titlePrefix = "LI3 Automatic Testing";

export const nQueries = 6;

export function sumList(l) {
  return l.reduce((a, b) => a + b, 0);
}
